import { defineStore, acceptHMRUpdate } from 'pinia'

type TState = {
  networkIsActive: boolean
  isScrolledToTop: boolean
  isLoading: boolean
  isLoadingAsync: boolean
  showQuickAccessMenu: boolean
  appBackgroundedByPermissionCheck?: boolean
}

const initialState: TState = {
  networkIsActive: false,
  isScrolledToTop: true,
  isLoading: false,
  isLoadingAsync: false,
  showQuickAccessMenu: false,
  appBackgroundedByPermissionCheck: false,
}

const useAppStateStore = defineStore('appStateStore', {
  state: () => {
    return { ...initialState }
  },
  actions: {
    toggleQuickAccessMenu() {
      this.showQuickAccessMenu = !this.showQuickAccessMenu
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStateStore, import.meta.hot))
}

export { useAppStateStore }
